import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { HiOutlineChatAlt2 } from "react-icons/hi";
import { CiSliderHorizontal } from "react-icons/ci";
import { AiOutlineClose } from "react-icons/ai";
import { FiPlus, FiMinus } from "react-icons/fi";
import { IoMdStarOutline, IoMdStar } from "react-icons/io";
import { TfiArrowCircleLeft, TfiArrowCircleRight } from "react-icons/tfi";
import { MdEditNote } from "react-icons/md";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronDown } from "lucide-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ReactSlider from "react-slider";
import { TbGridDots } from "react-icons/tb";
import Login from "../Layout/Login/Login";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { FaBars } from "react-icons/fa";
import { LuAlignJustify } from "react-icons/lu";


// StarRating Component
const StarRating = ({ rating }) => {
  const stars = Array(5).fill(false);
  for (let i = 0; i < rating; i++) {
    stars[i] = true;
  }

  return (
    <div className="d-flex">
      {stars.map((filled, index) => (
        <span key={index} className="text-gray-800">
          {filled ? (
            <IoMdStar /> // Filled star
          ) : (
            <IoMdStarOutline className="text-gray-400" /> // Empty star
          )}
        </span>
      ))}
    </div>
  );
};

export default function ProductList0({
  data,
  totalItems,
  subcategoryName,
  isReset,
  fetchNextPage,
  hasMore,
  isFetching,
  onResetFilters,
}) {
  const [filterOpen, setFilterOpen] = useState(false);
  const [products, setProducts] = useState([]);

  const [productsPerRow, setProductsPerRow] = useState(4);
  const [isSmallHeight, setIsSmallHeight] = useState(false);
  const [productImageAnimation, setProductImageAnimation] =
    useState("On Arrow Click ");
  const [openIndex, setOpenIndex] = useState(null);
  const [filters, setFilters] = useState([]);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [allFilters, setAllFilters] = useState([]);
  const [openSections, setOpenSections] = useState({});
  const [selectedSort, setSelectedSort] = useState("Select");
  const navigate = useNavigate();
  const [priceRange, setPriceRange] = useState([0, 10000]);
  const [selectedPriceRange, setSelectedPriceRange] = useState([0, 10000]);
  const [initialPriceRange] = useState([0, 10000]);
  const [priceAdjusted, setPriceAdjusted] = useState(false);
  const hoverIntervals = useRef({});
  const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedDimension, setSelectedDimension] = useState({
    min_height: 0,
    max_height: 1000,
    min_width: 0,
    max_width: 1000,
    min_depth: 0,
    max_depth: 1000,
  });

  const [selectedThickness, setSelectedThickness] = useState({
    min_thickness: 0,
    max_thickness: 100,
  });

  const [isHeightAdjusted, setIsHeightAdjusted] = useState(false);
  const [isWidthAdjusted, setIsWidthAdjusted] = useState(false);
  const [isDepthAdjusted, setIsDepthAdjusted] = useState(false);
  const [isThicknessAdjusted, setIsThicknessAdjusted] = useState(false);
  const rowOptions = [1, 2, 3, 4, 5];
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [favorites, setFavorites] = useState({});
  const [vibratingHearts, setVibratingHearts] = useState({});
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour)
    }
  }, []);


  const toggleFavorite = async (id, productId) => {
    const customerId = sessionStorage.getItem("accessToken");
    if (!customerId) {
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
        openLoginModal();
      }, 500);
      return;
    }

    const isNowFavorite = !favorites[id];
    setFavorites((prev) => ({ ...prev, [id]: isNowFavorite }));


    try {
      if (isNowFavorite) {
        await addToWishlist(productId);
      } else {
        await removeFromWishlist(productId);
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      setFavorites((prev) => ({ ...prev, [id]: !isNowFavorite }));
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => setVibratingHearts((prev) => ({ ...prev, [id]: false })), 500);
    }
  };


  const handleChangeRowProductsPerRow = () => {
    setProductsPerRow((prevRow) => {
      const currentIndex = rowOptions.indexOf(prevRow);
      const nextIndex = (currentIndex + 1) % rowOptions.length; // Cycle through options
      return rowOptions[nextIndex];
    });
  };

  const handleToggleHeight = () => {
    setIsSmallHeight((prev) => !prev);
  };

  const baseUrl =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);

  const formatProductsFromData = (data1) => {
    if (data1 && Array.isArray(data1)) {
      const formattedProducts = data1.map((product, index) => {
        const originalPrice = product.product_price
          ? parseFloat(product.product_price)
          : null;
        const finalPrice = product.final_product_price
          ? parseFloat(product.final_product_price)
          : originalPrice;
        const discount = product.offer_percentage
          ? `${product.offer_percentage}% OFF`
          : null;

        return {
          id: index + 1,
          brand: product.product_name || "Unknown Brand",
          name: product.product_name,
          product_auto_id: product.product_auto_id,
          price: `INR ${finalPrice}`,
          originalPrice: originalPrice ? `INR ${originalPrice}` : null,
          discount,
          rating: product.avg_rating || 0,
          image:
            product.product_images?.map(
              (img) => `${baseUrl}${img.product_image}`
            ) || [],
          colors: product.color_code ? [product.color_code] : [],
          todayOnly: product.new_arrival?.toLowerCase() === "yes",
        };
      });

      setProducts((prev) => {
        if (isReset) {
          return formattedProducts;
        } else {
          const existingIds = new Set(prev.map(p => p.product_auto_id));
          const newProducts = formattedProducts.filter(p => !existingIds.has(p.product_auto_id));

          return [...prev, ...newProducts];
        }
      });

    }
  };

  useEffect(() => {
    formatProductsFromData(data); // this is overwriting products
  }, [data]);


  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setMainCategoryId(data[0]?.main_category_auto_id || "");
      setSubCategoryId(data[0]?.sub_category_auto_id || "");
    }
  }, [data]);

  const syncWishlist = async (productList) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token || productList.length === 0) return;

    try {
      const wishlistArray = await getWishlistProducts();

      const wishlistSet = new Set(
        wishlistArray.map((item) => String(item.product_auto_id))
      );

      const updatedFavorites = {};
      productList.forEach((product) => {
        updatedFavorites[product.id] = wishlistSet.has(
          String(product.product_auto_id)
        );
      });

      setFavorites(updatedFavorites);
    } catch (error) {
      console.error("Wishlist sync failed:", error);
    }
  };
  useEffect(() => {
    if (products.length > 0) {
      syncWishlist(products);
    }
  }, [products]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500 &&
        !isFetching &&
        hasMore
      ) {
        fetchNextPage(); // ← This comes from props
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchNextPage, isFetching, hasMore]);


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);

      setProductsPerRow(parseInt(parsedStyle.product_per_row));
      setProductImageAnimation(parsedStyle.product_image_animation);
    }
  }, []);

  useEffect(() => {
    if (products.length > 0 && Object.keys(currentImageIndex).length === 0) {
      setCurrentImageIndex(
        products.reduce((acc, product) => {
          acc[product.id] = 0;
          return acc;
        }, {})
      );
    }
  }, [products]);

  const handlePreviousImage = (productId, totalImages) => {
    if (productImageAnimation === "On Arrow Click") {
      setCurrentImageIndex((prev) => ({
        ...prev,
        [productId]: (prev[productId] - 1 + totalImages) % totalImages, // Navigate backward
      }));
    }
  };

  const handleNextImage = (productId, totalImages) => {
    if (productImageAnimation === "On Arrow Click") {
      setCurrentImageIndex((prev) => ({
        ...prev,
        [productId]: (prev[productId] + 1) % totalImages, // Navigate forward
      }));
    }
  };

  useEffect(() => {
    if (productImageAnimation === "Auto Scrolling" && products.length > 0) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prev) => {
          const newIndexes = { ...prev };
          products.forEach((product) => {
            newIndexes[product.id] =
              (prev[product.id] + 1) % product.image.length;
          });
          return newIndexes;
        });
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [productImageAnimation, products.length]);

  // Hover effect for "On Hover Scrolling"
  const handleMouseEnter = (productId, totalImages) => {
    if (productImageAnimation === "On Hover Scrolling") {
      hoverIntervals.current[productId] = setInterval(() => {
        setCurrentImageIndex((prev) => ({
          ...prev,
          [productId]: (prev[productId] + 1) % totalImages, // Cycle through images
        }));
      }, 1000); // Change image every 1 second while hovering
    }
  };

  const handleMouseLeave = (productId) => {
    if (hoverIntervals.current[productId]) {
      clearInterval(hoverIntervals.current[productId]); // Stop changing images
      delete hoverIntervals.current[productId];
    }
  };

  useEffect(() => {
    document.body.style.overflow = filterOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [filterOpen]);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleOptionToggle = (filterName, value) => {
    setSelectedFilters((prev) => {
      const currentValues = prev[filterName] || [];
      const isSelected = currentValues.includes(value);

      // Special logic for "Discount" to allow only one selection
      if (filterName === "Discount") {
        return {
          ...prev,
          [filterName]: isSelected ? [] : [value], // Deselect if same, otherwise replace
        };
      }

      // Default behavior for other filters
      return {
        ...prev,
        [filterName]: isSelected
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value],
      };
    });
  };

  useEffect(() => {
    const fetchAllFilters = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_filter_menu`,
          {
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          }
        );

        if (response.data.status === 1) {
          const priceList = response.data.price_list;

          // Set price range once (from first object)
          if (priceList?.length > 0) {
            const min = Number(priceList[0].min_price);
            const max = Number(priceList[0].max_price);
            setPriceRange([min, max]);
            setSelectedPriceRange([min, max]);
          }

          const processedFilters = response.data.allfiltermenus.map(
            (filter) => {
              let options = [];
              let type = "select";

              switch (filter.filter_menu_name) {
                case "Price":
                  type = "slider";
                  options = priceList;
                  break;
                case "Manufacturers":
                  options = response.data.manufacturer_list.map((item) => ({
                    label: item.manufacturer_name,
                    value: item._id,
                  }));
                  break;
                case "Size":
                  options = response.data.size_list.map((item) => ({
                    label: item.size,
                    value: item.size_auto_id,
                  }));
                  break;
                case "Brand":
                  options = response.data.brand_list.map((item) => ({
                    label: item.brand_name,
                    value: item.brand_auto_id,
                  }));
                  break;
                case "Color":
                  options = response.data.color_list.map((item) => ({
                    label: item.color_name,
                    value: item._id,
                  }));
                  break;
                case "Material":
                  options = response.data.material_list.map((item) => ({
                    label: item.material_name,
                    value: item._id,
                  }));
                  break;
                case "Discount":
                  options = response.data.discount_list.map((item) => ({
                    label: `${item.discount_percent}%`,
                    value: item._id,
                  }));
                  break;
                case "Firmness":
                  options = response.data.firmness_list.map((item) => ({
                    label: item.unit,
                    value: item._id,
                  }));
                  break;
                case "Out of stock":
                  // Include "Include Out of Stock" option
                  options = [{ label: "Include out of stock", value: true }];
                  break;
                default:
                  options = [];
              }

              return {
                name: filter.filter_menu_name,
                type,
                options,
              };
            }
          );

          const additionalFilters = [
            // {
            //   name: "Dimension",
            //   type: "slider",
            //   options: [], // not needed, handled with sliders manually
            // },
            // {
            //   name: "Thickness",
            //   type: "slider",
            //   options: [],
            // },
          ];

          setAllFilters([...processedFilters, ...additionalFilters]);
        }
      } catch (error) {
        console.error("Error fetching filters:", error);
      }
    };

    fetchAllFilters();
  }, []);

  const getLabelsByValues = (filterName, values) => {
    const filter = allFilters.find((f) => f.name === filterName);
    if (!filter) return [];

    return values.map((val) => {
      const match = filter.options.find((opt) => opt.value === val);
      return match?.label || val; // fallback to value if label not found
    });
  };

  const applyFilters = async () => {
    setProducts([]);
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const app_type_id = sessionStorage.getItem("app_type_id");
    const user_auto_id =
      sessionStorage.getItem("accessToken") ||
      sessionStorage.getItem("admin_auto_id");
    const country = localStorage.getItem("country_name") || "India";

    const formData = new FormData();
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("app_type_id", app_type_id);
    if (priceAdjusted) {
      formData.append("min_price", selectedPriceRange[0]);
      formData.append("max_price", selectedPriceRange[1]);
    }
    formData.append("customer_auto_id", user_auto_id);
    formData.append("country", country);
    formData.append("limit", 10);
    formData.append("page_number", 1);
    formData.append("main_category_id", mainCategoryId);
    formData.append("sub_category_id", subCategoryId);

    // Apply filters
    for (const [filterName, values] of Object.entries(selectedFilters)) {
      if (values.length === 0) continue;

      switch (filterName) {
        case "Brand":
          formData.append("brand_id", values.join("|")); // IDs
          break;

        case "Size":
          formData.append("size_id", values.join("|")); // IDs
          break;

        case "Manufacturers":
          const manufacturerNames = getLabelsByValues("Manufacturers", values);
          formData.append("manufacturer_name", manufacturerNames.join("|"));
          break;

        case "Material":
          const materialNames = getLabelsByValues("Material", values);
          formData.append("material_name", materialNames.join("|"));
          break;

        case "Firmness":
          const firmnessTypes = getLabelsByValues("Firmness", values);
          formData.append("firmness_type", firmnessTypes.join("|"));
          break;

        case "Color":
          const colorNames = getLabelsByValues("Color", values);
          formData.append("color_name", colorNames.join("|"));
          break;

        case "Out of stock":
          if (values.includes(true)) {
            formData.append("out_of_stock", true);
          }
          break;

        case "Discount":
          formData.append("min_discount", 0);
          formData.append(
            "max_discount",
            parseInt(getLabelsByValues("Discount", values)[0])
          );
          break;

        default:
          // skip
          break;
      }
    }

    if (isHeightAdjusted) {
      formData.append("min_height", selectedDimension.min_height);
      formData.append("max_height", selectedDimension.max_height);
    }

    if (isWidthAdjusted) {
      formData.append("min_width", selectedDimension.min_width);
      formData.append("max_width", selectedDimension.max_width);
    }

    if (isDepthAdjusted) {
      formData.append("min_depth", selectedDimension.min_depth);
      formData.append("max_depth", selectedDimension.max_depth);
    }

    if (isThicknessAdjusted) {
      formData.append("min_thickness", selectedThickness.min_thickness);
      formData.append("max_thickness", selectedThickness.max_thickness);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_filter_products`,
        formData
      );

      if (response.data.status === 1) {
        formatProductsFromData(response.data.get_admin_filter_product_lists);
        setFiltersApplied(true);
      } else {
        setProducts([]); // No products found
        setFiltersApplied(false);
      }
    } catch (error) {
      console.error("Error fetching filtered products:", error);
      setFiltersApplied(false);
    }
  };

  function clearAllFilters() {
    setProducts([]);
    setSelectedFilters({});
    setPriceAdjusted(false); //  Reset slider tracking
    setSelectedPriceRange(initialPriceRange); //  Reset price range values
    resetDimensions();
    resetThickness();

    onResetFilters?.();
  }

  const handleDimensionChange = (newDimensions) => {
    setSelectedDimension(newDimensions);
  };

  const handleThicknessChange = (newThickness) => {
    setSelectedThickness(newThickness);
    setIsThicknessAdjusted(true);
  };

  const resetDimensions = () => {
    setIsHeightAdjusted(false);
    setIsWidthAdjusted(false);
    setIsDepthAdjusted(false);
    handleDimensionChange({
      min_height: 0,
      max_height: 1000,
      min_width: 0,
      max_width: 1000,
      min_depth: 0,
      max_depth: 1000,
    });
  };

  const resetThickness = () => {
    setIsThicknessAdjusted(false);
    setSelectedThickness({
      min_thickness: 0,
      max_thickness: 1000,
    });
  };

  // Inside ProductList0 component, add this useEffect
  useEffect(() => {
    if (products.length === 0) return; // Skip if no products

    const sortedProducts = [...products]; // Create a copy to avoid mutating state directly

    switch (selectedSort) {
      case "Price: Low to High":
        sortedProducts.sort((a, b) => {
          const priceA = parseFloat(a.price.replace("INR ", ""));
          const priceB = parseFloat(b.price.replace("INR ", ""));
          return priceA - priceB;
        });
        break;

      case "Price: High to Low":
        sortedProducts.sort((a, b) => {
          const priceA = parseFloat(a.price.replace("INR ", ""));
          const priceB = parseFloat(b.price.replace("INR ", ""));
          return priceB - priceA;
        });
        break;

      case "Newest Arrivals":
        sortedProducts.sort((a, b) => {
          // Products with todayOnly: true come first
          if (a.todayOnly && !b.todayOnly) return -1;
          if (!a.todayOnly && b.todayOnly) return 1;
          return 0; // Maintain order if both are same
        });
        break;

      default:
        // No sorting for "Select" or other cases
        break;
    }

    setProducts(sortedProducts); // Update state with sorted products
  }, [selectedSort, products.length]); // Depend on selectedSort and products.length

  return (
    <div className={`container p-2 ${webFont}`}>
      <style>
        {`
          @keyframes vibrate {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }
          .vibrate {
            animation: vibrate 0.3s linear;
          }
        `}
      </style>
      <h1 className="text-lg font-bold sm:text-xl md:text-2xl lg:text-3xl">
        {`${filtersApplied ? "Results" : subcategoryName} (${totalItems})`}
      </h1>
      {/* <p className="flex items-center hidden py-4 space-x-2 md:block">
        <HiOutlineChatAlt2 className="text-2xl" />
        <span className="underline">Talk to a Style Expert</span>
      </p> */}
      <div className="fixed left-0 z-10 w-full min-w-0 p-4 bg-white bottom-11 sm:static md:mb-3">


        {/* ⭐ MOBILE VIEW (Like Your Screenshot) ⭐ */}
        <div className="flex items-center justify-center gap-8 sm:hidden">

          {/* Filter */}
          <button
            className="flex items-center gap-1 text-black"
            onClick={() => setFilterOpen(!filterOpen)}
          >
            <CiSliderHorizontal className="text-2xl text-black" />
            <span className="text-[15px]">Filter</span>
            <ChevronDown size={16} />
          </button>

          {/* Vertical Divider */}
          <div className="h-6 w-[1px] bg-gray-300"></div>

          {/* Sort */}
          <DropdownMenu.Root onOpenChange={setIsSortOpen}>
            <DropdownMenu.Trigger asChild>
              <button className="flex items-center gap-1 text-black">
                <LuAlignJustify className="text-xl" />
                <span className="text-[15px]">Sort</span>
                <ChevronDown
                  size={16}
                  className={`transition-transform duration-300 ${isSortOpen ? "rotate-180" : "rotate-0"}`}
                />
              </button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
              <DropdownMenu.Content
                className="bg-white border rounded-md shadow-lg p-2 min-w-[150px]"
                sideOffset={5}
              >
                {["Price: Low to High", "Price: High to Low", "Newest Arrivals"].map(
                  (item) => (
                    <DropdownMenu.Item
                      key={item}
                      className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                      onSelect={() => setSelectedSort(item)}
                    >
                      {item}
                    </DropdownMenu.Item>
                  )
                )}
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
        </div>

        {/* ⭐ DESKTOP VIEW (NO CHANGES) ⭐ */}
        <div className="items-center justify-between hidden min-w-0 sm:flex">

          <div className="flex-wrap min-w-0 gap-2 overflow-x-auto whitespace-normal d-flex sm:flex-nowrap sm:whitespace-nowrap">

            <button
              className="border-1 border-black text-black hover:bg-gray-200 hover:text-white py-2.5 px-4 flex items-center space-x-2 rounded-md transition-all duration-300"
              onClick={() => setFilterOpen(!filterOpen)}
            >
              <CiSliderHorizontal className="text-2xl text-black" />
              <span> All Filters</span>
            </button>

            <div className="flex space-x-4">
              {filters.map((filter, index) => (
                <DropdownMenu.Root
                  key={index}
                  open={openIndex === index}
                  onOpenChange={(isOpen) => setOpenIndex(isOpen ? index : null)}
                >
                  <DropdownMenu.Trigger asChild>
                    <button className="flex items-center px-4 py-2 space-x-2 text-black transition-all duration-300 border border-black rounded-md hover:bg-gray-200 hover:text-white">
                      <span>{filter.name}</span>
                      <ChevronDown
                        size={16}
                        className={`transition-transform duration-300 ${openIndex === index ? "rotate-180" : "rotate-0"
                          }`}
                      />
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="bg-white border rounded-md shadow-lg p-3 min-w-[220px] max-h-[300px] overflow-y-auto z-[1000]"
                      sideOffset={5}
                      onPointerDownOutside={(e) => {
                        if (e.target.closest(".filter-option")) e.preventDefault();
                      }}
                    >
                      {filter.name === "Out of stock" ? (
                        <div className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            checked={selectedFilters["Out of stock"]?.length > 0}
                            onChange={() => handleOptionToggle("Out of stock", true)}
                            className="mr-2"
                          />
                          <label>Include out of stock</label>
                        </div>
                      ) : filter.type === "slider" ? (
                        <div className="flex flex-col px-2 space-y-2">
                          <label className="text-sm text-gray-700">
                            ₹{selectedPriceRange[0]} - ₹{selectedPriceRange[1]}
                          </label>
                          <ReactSlider
                            className="w-full h-2 bg-gray-300 rounded"
                            thumbClassName="w-4 h-4 bg-black rounded-full cursor-pointer"
                            trackClassName="bg-gray-300 h-4 rounded-lg"
                            min={initialPriceRange[0]}
                            max={initialPriceRange[1]}
                            step={100}
                            value={selectedPriceRange}
                            onChange={(values) => {
                              setSelectedPriceRange(values);
                              setPriceAdjusted(true);
                            }}
                          />
                        </div>
                      ) : filter.name === "Dimension" ? (
                        <>
                          {/* All your dimension sliders (unchanged) */}
                          {/* ... */}
                        </>
                      ) : filter.name === "Thickness" ? (
                        <>
                          {/* Thickness Slider (unchanged) */}
                          {/* ... */}
                        </>
                      ) : filter.options.length > 0 ? (
                        filter.options.map((option, i) => {
                          const isSelected = selectedFilters[filter.name]?.includes(
                            option.value
                          );
                          return (
                            <div
                              key={i}
                              onClick={() =>
                                handleOptionToggle(filter.name, option.value)
                              }
                              className={`filter-option cursor-pointer px-4 py-2 rounded flex items-center ${isSelected
                                ? "bg-black text-white"
                                : "hover:bg-gray-100"
                                }`}
                            >
                              <input
                                type="checkbox"
                                checked={isSelected}
                                readOnly
                                className="mr-2"
                              />
                              {option.label}
                            </div>
                          );
                        })
                      ) : (
                        <div className="px-4 py-2 text-gray-500 cursor-pointer">
                          No options available
                        </div>
                      )}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              ))}
            </div>
          </div>

          {/* <button
      className="hidden sm:block border border-black text-black font-semibold hover:bg-gray-200 hover:text-white py-[10px] px-3 flex items-center space-x-1 rounded-md mx-3"
      onClick={applyFilters}
    >
      Apply Filter
    </button> */}

          <div className="w-48 ml-auto sm:block">
            <DropdownMenu.Root onOpenChange={setIsSortOpen}>
              <DropdownMenu.Trigger asChild>
                <button className="relative flex items-center justify-between w-full h-12 pl-3 pr-3 bg-white border border-black rounded-md">
                  <label className="absolute left-3 top-[-10px] text-gray-400 text-sm px-1 bg-white">
                    Sort by
                  </label>
                  <span>{selectedSort}</span>
                  <ChevronDown
                    size={16}
                    className={`transition-transform duration-300 ${isSortOpen ? "rotate-180" : "rotate-0"
                      }`}
                  />
                </button>
              </DropdownMenu.Trigger>

              <DropdownMenu.Portal>
                <DropdownMenu.Content
                  className="bg-white border rounded-md shadow-lg p-2 min-w-[150px]"
                  sideOffset={5}
                >
                  {["Price: Low to High", "Price: High to Low", "Newest Arrivals"].map(
                    (item) => (
                      <DropdownMenu.Item
                        key={item}
                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                        onSelect={() => setSelectedSort(item)}
                      >
                        {item}
                      </DropdownMenu.Item>
                    )
                  )}
                </DropdownMenu.Content>
              </DropdownMenu.Portal>
            </DropdownMenu.Root>
          </div>
        </div>
      </div>



      <div className="flex items-center justify-end p-2 space-x-4">
        {(productsPerRow === 2 || productsPerRow === 3) && (
          <button onClick={handleToggleHeight} title="Toggle Height">
            {/* <MdEditNote size={45} /> */}
          </button>
        )}
        <button onClick={handleChangeRowProductsPerRow} title="Change Grid Layout">
          <TbGridDots size={35} />
        </button>
      </div>

      {/* 👉 NO PRODUCTS MESSAGE */}
      {!filtersApplied && products.length === 0 && (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
            alt="No products"
            className="w-32 h-32 mb-4 opacity-70"
          />
          <h2 className="text-lg font-semibold text-gray-700">
            No products available
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Try adjusting or clearing filters
          </p>
        </div>
      )}



      {/* 1 products per row */}
      {productsPerRow === 1 && (
        <div className="pt-5 row g-4">
          {products.map((product) => (
            <div className="col-12" key={product.product_auto_id}>
              {" "}
              {/* 1 card per row */}
              <div
                className="h-full border-0 cursor-pointer card d-flex flex-column"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                {/* Image Section */}
                <div
                  className="relative"
                  onMouseEnter={() =>
                    handleMouseEnter(product.id, product.image.length)
                  }
                  onMouseLeave={() => handleMouseLeave(product.id)}
                >
                  <img
                    src={product.image[currentImageIndex[product.id]]}
                    alt={product.name}
                    className="w-full h-48 sm:h-[650px] object-cover"
                  />

                  {productImageAnimation === "On Arrow Click" && (
                    <>
                      {/* Left Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviousImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 left-4"
                      >
                        <TfiArrowCircleLeft />
                      </button>

                      {/* Right Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNextImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 right-4"
                      >
                        <TfiArrowCircleRight />
                      </button>
                    </>
                  )}

                  {/* Show "Today Only" badge at the bottom-left of the image */}
                  {product.todayOnly && (
                    <div className="absolute flex items-center justify-center h-6 w-28 bottom-2 left-2"
                      style={{ backgroundColor: themeColor }}>
                      <p className="text-white text-sm font-bold pt-2.5">
                        New Arrival
                      </p>
                    </div>
                  )}
                  <button
                    className={`absolute bottom-2 right-2 p-2 border rounded-full bg-white ${vibratingHearts[product.id] ? "vibrate" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(product.id, product.product_auto_id);
                    }}
                  >
                    {favorites[product.id] ? (
                      <FaHeart className="text-xl text-red-500" />
                    ) : (
                      <FaRegHeart className="text-xl text-gray-600" />
                    )}
                  </button>
                </div>

                {/* Product Info Section */}
                <div className="flex-col flex-1 px-0 pt-0 card-body d-flex">
                  {/* Color Circle Section */}
                  <div className="flex gap-1 mt-2 mb-3">
                    {product.colors.slice(0, 5).map((color, index) => (
                      <div
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></div>
                    ))}
                    {product.colors.length > 5 && (
                      <div className="flex items-center justify-center w-4 h-4 ml-2 text-gray-400 ">
                        +{product.colors.length - 5}
                      </div>
                    )}
                  </div>

                  {/* Product Title and Description */}
                  <h5 className="font-bold card-title">{product.brand}</h5>
                  <p className="card-text">{product.name}</p>

                  {/* Pricing and Rating */}
                  <div className="mt-auto">
                    <div className="flex items-center justify-start gap-2">
                      <p className="text-lg font-bold "
                        style={{ color: themeColor }}>
                        {product.price}
                      </p>
                      {product.discount &&
                        parseFloat(product.discount.replace("% OFF", "")) > 0 &&
                        product.originalPrice && (
                          <p className="text-sm text-gray-500 line-through">
                            {product.originalPrice}
                          </p>
                        )}
                    </div>
                    <StarRating rating={product.rating} /> {/* Display stars */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 2 products per row */}
      {productsPerRow === 2 && (
        <div className="pt-5 row g-4">
          {products.map((product) => (
            <div className="col-6 col-sm-6 col-md-6 col-lg-6" key={product.product_auto_id}>
              <div
                className="border-0 cursor-pointer card h-100 d-flex flex-column "
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                {/* Image Section */}
                <div
                  className="relative"
                  onMouseEnter={() =>
                    handleMouseEnter(product.id, product.image.length)
                  }
                  onMouseLeave={() => handleMouseLeave(product.id)}
                >
                  <img
                    src={product.image[currentImageIndex[product.id]]}
                    alt={product.name}
                    className={`w-full object-cover ${isSmallHeight ? "sm:h-96" : "sm:h-[650px]"
                      }`}
                  />

                  {productImageAnimation === "On Arrow Click" && (
                    <>
                      {/* Left Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviousImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 left-4"
                      >
                        <TfiArrowCircleLeft />
                      </button>

                      {/* Right Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNextImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 right-4"
                      >
                        <TfiArrowCircleRight />
                      </button>
                    </>
                  )}

                  {/* Show "Today Only" badge at the bottom-left of the image */}
                  {product.todayOnly && (
                    <div className="absolute flex items-center justify-center h-6 w-28 bottom-2 left-2"
                      stlye={{ backgroundColor: themeColor }}>
                      <p className="text-white text-sm font-bold pt-2.5">
                        New Arrival
                      </p>
                    </div>
                  )}

                  <button
                    className={`absolute bottom-2 right-2 p-2 border rounded-full bg-white ${vibratingHearts[product.id] ? "vibrate" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(product.id, product.product_auto_id);
                    }}
                  >
                    {favorites[product.id] ? (
                      <FaHeart className="text-xl text-red-500" />
                    ) : (
                      <FaRegHeart className="text-xl text-gray-600" />
                    )}
                  </button>
                </div>

                {/* Product Info Section */}
                <div className="flex-col flex-1 px-0 pt-0 card-body d-flex">
                  {/* Color Circle Section */}
                  <div className="flex gap-1 mt-2 mb-3">
                    {product.colors.slice(0, 5).map((color, index) => (
                      <div
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></div>
                    ))}
                    {product.colors.length > 5 && (
                      <div className="flex items-center justify-center w-4 h-4 ml-2 text-gray-400 ">
                        +{product.colors.length - 5}
                      </div>
                    )}
                  </div>

                  {/* Product Title and Description */}
                  <h5 className="font-bold card-title">{product.brand}</h5>
                  <p className="card-text">{product.name}</p>
                  {/* Pricing and Rating */}
                  <div className="mt-auto">
                    <div className="flex items-center justify-start gap-2">
                      <p className="text-lg font-bold"
                        stlye={{ color: themeColor }}>
                        {product.price}
                      </p>
                      {product.discount &&
                        parseFloat(product.discount.replace("% OFF", "")) > 0 &&
                        product.originalPrice && (
                          <p className="text-sm text-gray-500 line-through">
                            {product.originalPrice}
                          </p>
                        )}
                    </div>
                    <StarRating rating={product.rating} /> {/* Display stars */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 3 products per row */}
      {productsPerRow === 3 && (
        <div className="pt-5 row g-4">
          {products.map((product) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-4" key={product.product_auto_id}>
              <div
                className="h-full border-0 cursor-pointer card d-flex flex-column"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                {/* Image Section */}
                <div
                  className="relative"
                  onMouseEnter={() =>
                    handleMouseEnter(product.id, product.image.length)
                  }
                  onMouseLeave={() => handleMouseLeave(product.id)}
                >
                  <img
                    src={product.image[currentImageIndex[product.id]]}
                    alt={product.name}
                    className={`w-full object-cover ${isSmallHeight ? "sm:h-96" : "sm:h-[600px]"
                      }`}
                  />

                  {productImageAnimation === "On Arrow Click" && (
                    <>
                      {/* Left Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviousImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 left-4"
                      >
                        <TfiArrowCircleLeft />
                      </button>

                      {/* Right Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNextImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 right-4"
                      >
                        <TfiArrowCircleRight />
                      </button>
                    </>
                  )}

                  {/* Show "Today Only" badge at the bottom-left of the image */}
                  {product.todayOnly && (
                    <div className="absolute flex items-center justify-center h-6 w-28 bottom-2 left-2"
                      stlye={{ backgroundColor: themeColor }}>
                      <p className="text-white text-sm font-bold pt-2.5">
                        New Arrival
                      </p>
                    </div>
                  )}
                  <button
                    className={`absolute bottom-2 right-2 p-2 border rounded-full bg-white ${vibratingHearts[product.id] ? "vibrate" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(product.id, product.product_auto_id);
                    }}
                  >
                    {favorites[product.id] ? (
                      <FaHeart className="text-xl text-red-500" />
                    ) : (
                      <FaRegHeart className="text-xl text-gray-600" />
                    )}
                  </button>
                </div>

                {/* Product Info Section */}
                <div className="flex-col flex-1 px-0 pt-0 card-body d-flex">
                  {/* Color Circle Section */}
                  <div className="flex gap-1 mt-2 mb-3">
                    {product.colors.slice(0, 5).map((color, index) => (
                      <div
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></div>
                    ))}
                    {product.colors.length > 5 && (
                      <div className="flex items-center justify-center w-4 h-4 ml-2 text-gray-400 ">
                        +{product.colors.length - 5}
                      </div>
                    )}
                  </div>

                  {/* Product Title and Description */}
                  <h5 className="font-bold card-title">{product.brand}</h5>
                  <p className="card-text">{product.name}</p>

                  {/* Pricing and Rating */}
                  <div className="mt-auto">
                    <div className="flex items-center justify-start gap-2">
                      <p className="text-lg font-bold "
                        stlye={{ color: themeColor }}>
                        {product.price}
                      </p>
                      {product.discount &&
                        parseFloat(product.discount.replace("% OFF", "")) > 0 &&
                        product.originalPrice && (
                          <p className="text-sm text-gray-500 line-through">
                            {product.originalPrice}
                          </p>
                        )}
                    </div>
                    <StarRating rating={product.rating} /> {/* Display stars */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 4 products per row */}
      {productsPerRow === 4 && (
        <div className="pt-0 row g-4">
          {products.map((product) => (
            <div className="col-6 col-sm-6 col-md-4 col-lg-3" key={product.product_auto_id}>
              <div
                className="border-0 cursor-pointer card h-100 d-flex flex-column"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                {/* Image Section */}
                <div
                  className="relative"
                  onMouseEnter={() =>
                    handleMouseEnter(product.id, product.image.length)
                  }
                  onMouseLeave={() => handleMouseLeave(product.id)}
                >
                  <img
                    src={product.image[currentImageIndex[product.id]]}
                    alt={product.name}
                    className="object-cover w-full h-48 sm:h-96"
                  />

                  {productImageAnimation === "On Arrow Click" && (
                    <>
                      {/* Left Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviousImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 left-4"
                      >
                        <TfiArrowCircleLeft />
                      </button>

                      {/* Right Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNextImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 right-4"
                      >
                        <TfiArrowCircleRight />
                      </button>
                    </>
                  )}

                  {/* Show "Today Only" badge at the bottom-left of the image */}
                  {product.todayOnly && (
                    <div className="absolute flex items-center justify-center h-6 w-28 bottom-2 left-2"
                      style={{ backgroundColor: themeColor }}>
                      <p className="text-white text-sm font-bold pt-2.5">
                        New Arrival
                      </p>
                    </div>
                  )}
                  <button
                    className={`absolute bottom-2 right-2 p-2 border rounded-full bg-white ${vibratingHearts[product.id] ? "vibrate" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(product.id, product.product_auto_id);
                    }}
                  >
                    {favorites[product.id] ? (
                      <FaHeart className="text-xl text-red-500" />
                    ) : (
                      <FaRegHeart className="text-xl text-gray-600" />
                    )}
                  </button>
                </div>

                {/* Product Info Section */}
                <div className="flex-col flex-1 px-0 pt-0 card-body d-flex">
                  {/* Color Circle Section */}
                  <div className="flex gap-1 mt-2 mb-3">
                    {product.colors.slice(0, 5).map((color, index) => (
                      <div
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></div>
                    ))}
                    {product.colors.length > 5 && (
                      <div className="flex items-center justify-center w-4 h-4 ml-2 text-gray-400 ">
                        +{product.colors.length - 5}
                      </div>
                    )}
                  </div>

                  {/* Product Title and Description */}
                  <h5 className="font-bold card-title">{product.brand}</h5>
                  <p className="card-text">{product.name}</p>

                  {/* Pricing and Rating */}
                  <div className="mt-auto">
                    <p className="font-bold " style={{ color: themeColor }}>{product.price}</p>
                    {product.discount &&
                      parseFloat(product.discount.replace("% OFF", "")) > 0 &&
                      product.originalPrice && (
                        <p className="text-gray-500 line-through">
                          {product.originalPrice}
                        </p>
                      )}
                    <StarRating rating={product.rating} /> {/* Display stars */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 5 products per row */}
      {productsPerRow === 5 && (
        <div className="pt-5 row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4 ">
          {products.map((product) => (
            <div className="col" key={product.product_auto_id}>
              <div
                className="border-0 cursor-pointer card h-100 d-flex flex-column"
                onClick={() =>
                  navigate(`/product-detail/${product.product_auto_id}`)
                }
              >
                {/* Image Section */}
                <div
                  className="relative"
                  onMouseEnter={() =>
                    handleMouseEnter(product.id, product.image.length)
                  }
                  onMouseLeave={() => handleMouseLeave(product.id)}
                >
                  <img
                    src={product.image[currentImageIndex[product.id]]}
                    alt={product.name}
                    className="object-cover w-full h-48 sm:h-96"
                  />
                  {productImageAnimation === "On Arrow Click" && (
                    <>
                      {/* Left Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviousImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 left-4"
                      >
                        <TfiArrowCircleLeft />
                      </button>

                      {/* Right Arrow */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNextImage(product.id, product.image.length);
                        }}
                        className="absolute text-3xl text-white transform -translate-y-1/2 top-1/2 right-4"
                      >
                        <TfiArrowCircleRight />
                      </button>
                    </>
                  )}

                  {/* "Today Only" Badge */}
                  {product.todayOnly && (
                    <div className="absolute flex items-center justify-center h-6 w-28 bottom-2 left-2"
                      style={{ backgroundColor: themeColor }}>
                      <p className="text-white text-sm font-bold pt-2.5">
                        New Arrival
                      </p>
                    </div>
                  )}
                  <button
                    className={`absolute bottom-2 right-2 p-2 border rounded-full bg-white ${vibratingHearts[product.id] ? "vibrate" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(product.id, product.product_auto_id);
                    }}
                  >
                    {favorites[product.id] ? (
                      <FaHeart className="text-xl text-red-500" />
                    ) : (
                      <FaRegHeart className="text-xl text-gray-600" />
                    )}
                  </button>
                </div>

                {/* Product Info Section */}
                <div className="flex-col flex-1 px-0 pt-0 card-body d-flex">
                  {/* Color Circle Section */}
                  <div className="flex gap-1 mt-2 mb-3">
                    {product.colors.slice(0, 5).map((color, index) => (
                      <div
                        key={index}
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                      ></div>
                    ))}
                    {product.colors.length > 5 && (
                      <div className="flex items-center justify-center w-4 h-4 ml-2 text-gray-400">
                        +{product.colors.length - 5}
                      </div>
                    )}
                  </div>

                  {/* Product Title and Description */}
                  <h5 className="font-bold card-title">{product.brand}</h5>
                  <p className="truncate card-text">{product.name}</p>

                  {/* Pricing and Rating */}
                  <div className="mt-auto">
                    <div className="flex items-center justify-start gap-2">
                      <p className="text-lg font-bold "
                        style={{ color: themeColor }}>
                        {product.price}
                      </p>
                      {product.discount &&
                        parseFloat(product.discount.replace("% OFF", "")) > 0 &&
                        product.originalPrice && (
                          <p className="text-sm text-gray-500 line-through">
                            {product.originalPrice}
                          </p>
                        )}
                    </div>
                    <StarRating rating={product.rating} /> {/* Display stars */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {filterOpen && (
        <div>
          <div
            className="fixed inset-0 z-40 bg-black bg-opacity-50"
            onClick={() => setFilterOpen(false)}
          ></div>
          <div className="fixed top-0 right-0 z-50 flex flex-col w-full h-full p-4 transition-transform transform translate-x-0 bg-white border-l shadow-lg sm:w-4/12 sm:border-l-0 sm:border-t">
            <div className="flex justify-between p-4">
              <h2 className="text-2xl fw-bold">Filters</h2>
              <button
                className="py-1 text-2xl text-black"
                onClick={() => setFilterOpen(false)}
              >
                <AiOutlineClose />
              </button>
            </div>
            <div
              className="flex-grow px-4 mt-4 overflow-y-auto no-scrollbar"
              style={{ maxHeight: "70vh", scrollbarWidth: "none" }}
            >
              {allFilters.map((filter, index) => (
                <div key={index} className="py-4 border-b border-black">
                  <button
                    className="flex items-center justify-between w-full text-lg font-semibold"
                    onClick={() => toggleSection(filter.name)}
                  >
                    {filter.name}{" "}
                    {openSections[filter.name] ? <FiMinus /> : <FiPlus />}
                  </button>
                  {openSections[filter.name] && (
                    <div className="px-4 mt-2">
                      {filter.name === "Out of Stock" ? (
                        <div className="space-y-2">
                          <label className="flex items-center space-x-2 text-sm">
                            <input
                              type="checkbox"
                              className="accent-black"
                              checked={
                                selectedFilters["Out of Stock"]?.length > 0
                              }
                              onChange={() =>
                                handleOptionToggle("Out of Stock", true)
                              }
                            />
                            <span>Include out of stock</span>
                          </label>
                        </div>
                      ) : filter.name === "Price" ? (
                        <div className="px-2 mt-4">
                          <ReactSlider
                            className="w-full h-2 bg-gray-300 rounded"
                            thumbClassName="w-4 h-4 bg-black rounded-full cursor-pointer"
                            trackClassName="bg-gray-300 h-4 rounded-lg"
                            min={initialPriceRange[0]}
                            max={initialPriceRange[1]}
                            step={100}
                            value={selectedPriceRange}
                            onChange={(values) => {
                              setSelectedPriceRange(values);
                              setPriceAdjusted(true);
                            }}
                          />
                          <div className="flex justify-between mt-2 text-sm">
                            <span>₹{selectedPriceRange[0]}</span>
                            <span>₹{selectedPriceRange[1]}</span>
                          </div>
                        </div>
                      ) : filter.name === "Dimension" ? (
                        <div className="space-y-4">
                          <div className="flex flex-col px-2 space-y-2">
                            <label className="text-sm text-gray-700">
                              Height: {selectedDimension.min_height} -{" "}
                              {selectedDimension.max_height}
                            </label>
                            <ReactSlider
                              className="w-full h-2 bg-gray-300 rounded"
                              thumbClassName="w-4 h-4 bg-black rounded-full cursor-pointer"
                              trackClassName="bg-gray-300 h-4 rounded-lg"
                              min={0}
                              max={1000}
                              step={10}
                              value={[
                                selectedDimension.min_height,
                                selectedDimension.max_height,
                              ]}
                              onChange={(values) => {
                                setIsHeightAdjusted(true);
                                handleDimensionChange({
                                  ...selectedDimension,
                                  min_height: values[0],
                                  max_height: values[1],
                                });
                              }}
                            />
                          </div>

                          <div className="flex flex-col px-2 space-y-2">
                            <label className="text-sm text-gray-700">
                              Width: {selectedDimension.min_width} -{" "}
                              {selectedDimension.max_width}
                            </label>
                            <ReactSlider
                              className="w-full h-2 bg-gray-300 rounded"
                              thumbClassName="w-4 h-4 bg-black rounded-full cursor-pointer"
                              trackClassName="bg-gray-300 h-4 rounded-lg"
                              min={0}
                              max={1000}
                              step={10}
                              value={[
                                selectedDimension.min_width,
                                selectedDimension.max_width,
                              ]}
                              onChange={(values) => {
                                setIsWidthAdjusted(true);
                                handleDimensionChange({
                                  ...selectedDimension,
                                  min_width: values[0],
                                  max_width: values[1],
                                });
                              }}
                            />
                          </div>

                          <div className="flex flex-col px-2 space-y-2">
                            <label className="text-sm text-gray-700">
                              Depth: {selectedDimension.min_depth} -{" "}
                              {selectedDimension.max_depth}
                            </label>
                            <ReactSlider
                              className="w-full h-2 bg-gray-300 rounded"
                              thumbClassName="w-4 h-4 bg-black rounded-full cursor-pointer"
                              trackClassName="bg-gray-300 h-4 rounded-lg"
                              min={0}
                              max={1000}
                              step={10}
                              value={[
                                selectedDimension.min_depth,
                                selectedDimension.max_depth,
                              ]}
                              onChange={(values) => {
                                setIsDepthAdjusted(true);
                                handleDimensionChange({
                                  ...selectedDimension,
                                  min_depth: values[0],
                                  max_depth: values[1],
                                });
                              }}
                            />
                          </div>
                        </div>
                      ) : filter.name === "Thickness" ? (
                        <div className="flex flex-col px-2 space-y-2">
                          <label className="text-sm text-gray-700">
                            Thickness: {selectedThickness.min_thickness} -{" "}
                            {selectedThickness.max_thickness}
                          </label>
                          <ReactSlider
                            className="w-full h-2 bg-gray-300 rounded"
                            thumbClassName="w-4 h-4 bg-black rounded-full cursor-pointer"
                            trackClassName="bg-gray-300 h-4 rounded-lg"
                            min={0}
                            max={100}
                            step={1}
                            value={[
                              selectedThickness.min_thickness,
                              selectedThickness.max_thickness,
                            ]}
                            onChange={(values) => {
                              handleThicknessChange({
                                ...selectedThickness,
                                min_thickness: values[0],
                                max_thickness: values[1],
                              });
                            }}
                          />
                        </div>
                      ) : filter.options.length > 0 ? (
                        <div className="space-y-2">
                          {filter.options.map((option, idx) => (
                            <label
                              key={idx}
                              className="flex items-center space-x-2 text-sm"
                            >
                              <input
                                type="checkbox"
                                className="accent-black"
                                checked={
                                  selectedFilters[filter.name]?.includes(
                                    option.value
                                  ) || false
                                }
                                onChange={() =>
                                  handleOptionToggle(filter.name, option.value)
                                }
                              />
                              <span>{option.label}</span>
                            </label>
                          ))}
                        </div>
                      ) : (
                        <p className="text-gray-500">No options available</p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="flex justify-between p-2 pb-4">
              <button
                className="py-2 px-4 border border-black text-black bg-white w-1/2 mr-2 rounded-lg sm:py-0.5"
                onClick={() => {
                  clearAllFilters();
                }}
              >
                Clear All
              </button>

              <button
                className="py-3 px-4  text-white w-1/2 rounded-lg sm:py-0.5"
                onClick={applyFilters}
                style={{ backgroundColor: themeColor }}
              >
                View Items
              </button>
            </div>
          </div>
        </div>
      )}
      {isLoginModalOpen && (
        <Login isOpen={isLoginModalOpen} onClose={closeLoginModal} />
      )}
    </div>
  );
}
